import { render } from "./Coordinates.vue?vue&type=template&id=48fee0a1"
import script from "./Coordinates.vue?vue&type=script&lang=js"
export * from "./Coordinates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__